document.addEventListener('DOMContentLoaded', function() {
  
  // Miktar Arttır / Azalt butonları
  const qtyBtns = document.querySelectorAll('.qty-btn');
  
  qtyBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const input = this.parentElement.querySelector('input');
      let value = parseInt(input.value);
      
      if (this.classList.contains('plus')) {
        value++;
      } else {
        if (value > 0) value--;
      }
      
      input.value = value;
      
      // Değer değişince sepeti otomatik güncelle (Sayfa yenilenir)
      // Daha modern bir yapı için buraya AJAX eklenebilir ama 
      // en sağlam yöntem formu tetiklemektir.
      document.getElementById('cart-form').submit();
    });
  });

});

// Kupon Kodunu Checkout'a Taşıma Fonksiyonu
function submitWithDiscount(e) {
  e.preventDefault(); // Normal submit'i durdur
  
  const discountCode = document.getElementById('discount-code').value;
  const form = document.getElementById('cart-form');
  
  // Eğer kupon kodu girildiyse URL'e ekle
  if (discountCode) {
    const actionUrl = new URL(form.action, window.location.origin);
    // Shopify checkout'a yönlendirirken discount parametresi ekler
    form.action = `/checkout?discount=${discountCode}`;
  }
  
  form.submit();
}